import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import * as _ from 'lodash';

import {
    FormsService,
    ManualsService,
    SettingsService,
    SettingsNotificationsService,
    ParametersService,
    SettingsSaveService, SettingsTilesService,
    SubtitlesService, ViewsService,
} from '../../core';
import {StateService} from "@uirouter/core";


@Component({
    selector: 'settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
    hideTab: boolean = false;

    constructor(
        private forms: FormsService,
        private location: Location,
        public manuals: ManualsService,
        private parameters: ParametersService,
        public settings: SettingsService,
        public settingsSave: SettingsSaveService,
        private settingsTiles: SettingsTilesService,
        public settingsNotifications: SettingsNotificationsService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        public views: ViewsService,
    ) {
    }

    ngOnInit() {
        this.hideTab = this.location.path().includes("jawo");
        this.settings.modules = _.cloneDeep(this.parameters.modules);
        this.settings.setModulesInformation();
        this.settingsSave.showInput = false;
        this.settingsSave.loader = false;
        this.manuals.getManualsList();
        this.settingsTiles.setTiles()
        this.settingsNotifications.getAllPushDevices(true);
        this.settingsNotifications.getAssignedAccounts(true);

        if (this.forms.isCompanySubdomain('kolton')) {
            this.forms.getContactFormData();
        }
        if (this.views.isMobileView()) {
            this.settings.showMobileMenu = true;
            this.settings.showCard = false;
        }
        if (this.views.isMobileView() && this.$state.is(`settings.registration_new_module`)) {
            this.settings.showMobileMenu = false;
            this.settings.showCard = true;
        }
        this.settings.title = this.subtitle(845);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }
}
